import { Flex, Text } from '@chakra-ui/react';
import { Trans, t } from '@lingui/macro';

import { YOPLANNING_COM_URL } from '../../../../constants';
import Image from '../../Image';

const PoweredBy = () => {
  const handleOnClick = () => window.open(YOPLANNING_COM_URL, '_blank', 'noopener,noreferrer');

  return (
    <Flex mr={{ base: '1rem', sm: '0' }} cursor="pointer" _hover={{ bg: 'gray.100' }} padding=".5rem 1rem" borderRadius="md" onClick={handleOnClick}>
      <Text fontSize="0.7rem" mr=".5em" color="#6B7785" alignSelf="center">
        <Trans>Powered by</Trans>
      </Text>
      <Image
        imageUrl={'/assets/logo-planning-black.svg'}
        addYoplanningRootToSrc={false}
        // Those sizes keep the original ratio!!
        w="83px"
        maxW="83px"
        maxH="24px"
        alt={t`Powered by Yoplanning`}
        style={{ objectFit: 'contain' }}
      />
    </Flex>
  );
};

export default PoweredBy;
